import { render, staticRenderFns } from "./LibroPreschool.vue?vue&type=template&id=4e5ae477"
import script from "./LibroPreschool.vue?vue&type=script&lang=js"
export * from "./LibroPreschool.vue?vue&type=script&lang=js"
import style0 from "./LibroPreschool.vue?vue&type=style&index=0&id=4e5ae477&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports